export default __webpack_public_path__ + "static/media/regulatory--dual-lanes-go-left-or-right--g1.20dace34.png";